// extracted by mini-css-extract-plugin
export default {"container":"withdrawDetails_container__iG4aW","list":"withdrawDetails_list__aRVOG","item":"withdrawDetails_item__i65YE","listTitle":"withdrawDetails_listTitle__MzHtU"};